export default "__VITE_ASSET__CqjiEZoc__"